// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/InputColor/index.less
// module id = 1931
// module chunks = 0